import { createFileRoute, redirect, Navigate } from '@tanstack/react-router';
import { checkRoutePermission } from '@/components/Auth/checkUserPermissions.ts';
import { getDefaultView } from '@/utils/viewHelpers';
import { DocumentHead } from '@/components/core/DocumentHead';

export const Route = createFileRoute(
  '/$tenantId/_layout/students/child-and-youth/',
)({
  component: StudentChildAndYouthRedirect,
  beforeLoad: ({ params }) => {
    const hasPermission = checkRoutePermission({
      permission: 'organization:viewer',
    });
    if (!hasPermission) {
      throw redirect({ to: '/$tenantId', params });
    }
  },
});

function StudentChildAndYouthRedirect() {
  const { tenantId } = Route.useParams();
  const view = getDefaultView('students/child-and-youth');

  return (
    <>
      <DocumentHead
        titleKey="page.students.child-and-youth.title"
        descriptionKey="page.students.child-and-youth.description"
        resetOnUnmount={false}
      />
      <Navigate
        to="/$tenantId/students/child-and-youth/$view"
        params={{ tenantId, view }}
        replace
      />
    </>
  );
}
